import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { AuthService } from '../../services/auth/auth.service';
import { WallboardService } from '../../services/wallboard/wallboard.service'
import { environment } from '../../../environments/environment';
import { ConfigService } from '../../services/config/config.service';

@Component({
  selector: 'app-nav',
  templateUrl: './nav.component.html',
  styleUrls: ['./nav.component.css']
})
export class NavComponent implements OnInit {

  url: string;
  rootUrl = 'home';
  telecomHover:boolean = false;

  //add telecom to nav config? do we need to add a button 

  navConfigs = {
    home: {
      configRole: null,
      wallRole: null
    },
    telecom: {
      dispositionUrl: '/disposition',
      groupMessageUrl: '/group-message',
      queueMessageUrl: '/queue-message',
      hiMarleyUrl: '/hiMarley-management',
      closureUrl: '/closures',
      shutDownUrl: '/emergencyShutdown',
      connectUtilUrl: '/connectUtil',
      ctrProcessingUrl: '/ctrProcessing',
      applicationDataUrl: '/applicationData',
      buiManagerUrl: 'health/voicemailManager'
    },
    health: {
      configRole: environment.authRoles.healthConfig,
      wallRole: environment.authRoles.healthWallboard,
      configUrl: '/health/config',
      addConfigUrl: '/health/add',
      wbUrl: '/health/wallboard',
      wbConfigUrl: '/health/wallboard/config',
      dispositionUrl: 'health/disposition',
      groupMessageUrl: 'health/group-message',
      queueMessageUrl: 'health/queue-message',
      closureUrl: 'health/closures',
      shutDownUrl: 'health/emergencyShutdown',
      buiManagerUrl: 'health/voicemailManager'
    },
    life: {
      configRole: environment.authRoles.lifeConfig,
      wallRole: environment.authRoles.lifeWallboard,
      configUrl: '/life/config',
      addConfigUrl: '/life/add',
      wbUrl: '/life/wallboard',
      wbConfigUrl: '/life/wallboard/config',
      dispositionUrl: 'life/disposition',
      groupMessageUrl: 'life/group-message',
      queueMessageUrl: 'life/queue-message',
      closureUrl: 'life/closures',
      shutDownUrl: 'life/emergencyShutdown',
      buiManagerUrl: 'life/voicemailManager'
    },
    fnol: {
      configRole: environment.authRoles.fnolConfig,
      wallRole: environment.authRoles.fnolWallboard,
      configUrl: '/fnol/config',
      addConfigUrl: '/fnol/add',
      wbUrl: '/fnol/wallboard',
      wbConfigUrl: '/fnol/wallboard/config',
      dispositionUrl: 'fnol/disposition',
      groupMessageUrl:'fnol/group-message',
      queueMessageUrl: 'fnol/queue-message',
      closureUrl: 'fnol/closures',
      shutDownUrl: 'fnol/emergencyShutdown',
      buiManagerUrl: 'fnol/voicemailManager'
    },
    claims: {
      configRole: environment.authRoles.claimsConfig,
      wallRole: environment.authRoles.claimsWallboard,
      configUrl: '/claims/config',
      addConfigUrl: '/claims/add',
      wbUrl: '/claims/wallboard',
      wbConfigUrl: '/claims/wallboard/config',
      dispositionUrl: 'claims/disposition',
      groupMessageUrl: 'claims/group-message',
      queueMessageUrl: 'claims/queue-message',
      closureUrl: 'claims/closures',
      shutDownUrl: 'claims/emergencyShutdown',
      buiManagerUrl: 'claims/voicemailManager'
    },
    hr: {
      configRole: environment.authRoles.hrConfig,
      wallRole: environment.authRoles.hrWallboard,
      configUrl: '/hr/config',
      addConfigUrl: '/hr/add',
      wbUrl: '/hr/wallboard',
      wbConfigUrl: '/hr/wallboard/config',
      dispositionUrl: 'hr/disposition',
      groupMessageUrl: 'hr/group-message',
      queueMessageUrl: 'hr/queue-message',
      closureUrl: 'hr/closures',
      shutDownUrl: 'hr/emergencyShutdown',
      buiManagerUrl: 'hr/voicemailManager'
    },
    pnc:{
      configRole: environment.authRoles.pncConfig,
      wallRole: environment.authRoles.pncWallboard,
      configUrl: '/pnc/config',
      addConfigUrl: '/pnc/add',
      wbUrl: '/pnc/wallboard',
      wbConfigUrl: '/pnc/wallboard/config',
      dispositionUrl: 'pnc/disposition',
      groupMessageUrl: 'pnc/group-message',
      queueMessageUrl: 'pnc/queue-message',
      hiMarleyUrl: 'pnc/hiMarley-management',
      closureUrl: 'pnc/closures',
      shutDownUrl: 'pnc/emergencyShutdown',
      buiManagerUrl: 'pnc/voicemailManager'
    },
    insidesales:{
      configRole: environment.authRoles.insidesalesConfig,
      wallRole: environment.authRoles.insidesalesWallboard,
      configUrl: '/insidesales/config',
      addConfigUrl: '/insidesales/add',
      wbUrl: '/insidesales/wallboard',
      wbConfigUrl: '/insidesales/wallboard/config',
      dispositionUrl: 'insidesales/disposition',
      groupMessageUrl: 'insidesales/group-message',
      queueMessageUrl: 'insidesales/queue-message',
      closureUrl: 'insidesales/closures',
      shutDownUrl: 'insidesales/emergencyShutdown',
      buiManagerUrl: 'insidesales/voicemailManager'
    },
    it: {
      configRole: environment.authRoles.itConfig,
      wallRole: environment.authRoles.itWallboard,
      configUrl: '/it/config',
      addConfigUrl: '/it/add',
      wbUrl: '/it/wallboard',
      wbConfigUrl: '/it/wallboard/config',
      dispositionUrl: 'it/disposition',
      groupMessageUrl: 'it/group-message',
      queueMessageUrl: 'it/queue-message',
      hiMarleyUrl: 'it/hiMarley-management',
      closureUrl: 'it/closures',
      shutDownUrl: 'it/emergencyShutdown',
      buiManagerUrl: 'it/voicemailManager'
    },
    aacc:{
      configRole: environment.authRoles.aaccConfig,
      wallRole: environment.authRoles.aaccWallboard,
      configUrl: '/aacc/config',
      addConfigUrl: '/aacc/add',
      wbUrl: '/aacc/wallboard',
      wbConfigUrl: '/aacc/wallboard/config',
      dispositionUrl: 'aacc/disposition',
      groupMessageUrl: 'aacc/group-message',
      queueMessageUrl: 'aacc/queue-message',
      closureUrl: 'aacc/closures',
      shutDownUrl: 'aacc/emergencyShutdown',
      buiManagerUrl: 'aacc/voicemailManager'
    },
    auto: {
      configRole: environment.authRoles.autoConfig,
      wallRole: environment.authRoles.autoWallboard,
      configUrl: '/claims/config',
      addConfigUrl: '/claims/add',
      wbUrl: '/claims/wallboard',
      wbConfigUrl: '/claims/wallboard/config'
    },
    recordingSearch: {
      configRole: environment.authRoles.policySearch,
      recordingSearchUrl: '/recordingSearch'
    }//Recording Search may need updated auth
  }

  configRole = this.navConfigs[this.rootUrl].configRole;
  wallRole = this.navConfigs[this.rootUrl].wallRole;
  buiManagerRole = environment.authRoles.buiManager;
  telecomRole = environment.roles.telecom;
  ctrRole = environment.roles.ctr;
  specialMsgRole = environment.authRoles.specialMsg;
  specialMsgSuperRole = environment.authRoles.specialMsgSuper;
  policySearchRole = environment.authRoles.policySearch;
  claimSearchRole = environment.authRoles.claimSearch;
  DNISConfigRole = environment.authRoles.DNISConfig;
  pncRole = environment.authRoles.pnc;
  
  
  constructor(
    private router: Router, public auth: AuthService,
    public wallboardService: WallboardService,
    public configService: ConfigService
  ) { }


  ngOnInit() {
    this.router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
          return;
      }
      this.url = this.router.url;
      console.log(this.url);
      if (this.url.includes('health')) {
        this.rootUrl = 'health'
        this.configService.setLOB('health');
      } else if (this.url.includes('life')) {
        this.rootUrl = 'life'
        this.configService.setLOB('life');
      } else if (this.url.includes('fnol')) {
        this.rootUrl = 'fnol'
        this.configService.setLOB('fnol');
      } else if (this.url.includes('claims')) {
        this.rootUrl = 'claims'
        this.configService.setLOB('claims');
      } else if (this.url.includes('auto')) {
        this.rootUrl = 'auto'
        this.configService.setLOB('auto');
      } else if (this.url.includes('pnc')) {
        this.rootUrl = 'pnc'
        this.configService.setLOB('pnc');
      } else if (this.url.includes('insidesales')) {
        this.rootUrl = 'insidesales'
        this.configService.setLOB('insidesales');
      } else if (this.url.includes('hr')) {
        this.rootUrl = 'hr'
        this.configService.setLOB('hr');
      } else if (this.url.includes('it')) {
          this.rootUrl = 'it'
          this.configService.setLOB('it');
      } else if (this.url.includes('aacc')) {
        this.rootUrl = 'aacc'
        this.configService.setLOB('aacc');
      } else {
        this.rootUrl = 'home'
      }

      // only fnol should have access to the old config pages
      this.configRole = this.navConfigs.fnol.configRole           
      this.wallRole = this.navConfigs[this.rootUrl].wallRole;
    });
  }

  signout() {
    this.auth.logout();
  }

  //for routes that lead to pages for both LOB and telecom admins
  getRoute(routeKey: string){
    if(routeKey in this.navConfigs[this.rootUrl]){
      return this.navConfigs[this.rootUrl][routeKey];
    }
    if(this.auth.memberOf.includes(environment.roles.telecom) && routeKey in this.navConfigs.telecom){
      return this.navConfigs.telecom[routeKey];
    }
    return null;
  }

  showNavElement(role: string){
    if(this.auth.memberOf.includes(role)){
      return true;
    }
    if(this.auth.memberOf.includes(environment.roles.telecom) && this.rootUrl != 'home'){
      return true;
    }
    return false;
  }

}
